import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

interface StatsCardProps {
  title: string;
  icon: React.ReactNode;
  value: number | string;
  percentage: number; // positive or negative
  onClick?: () => void; // optional click handler
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  icon,
  value,
  percentage,
  onClick,
}) => {
  const isPositive = percentage >= 0;

  return (
    <Card
      sx={{
        borderRadius: 3,
        background: "linear-gradient(135deg, #EAEAF8, #D4D4F8)",
        boxShadow: "0px 3px 6px rgba(0,0,0,0.1)",
        minWidth: 200,
        flex: "1 1 auto", // allow it to shrink/grow
        maxWidth: { xs: "100%", sm: "48%", md: "30%", lg: "22%" }, // responsive widths
        transition: "all 0.3s ease-in-out",
        cursor: "pointer",
        "&:hover": {
          transform: "scale(1.05)",
          boxShadow: "0px 6px 12px rgba(0,0,0,0.2)",
        },
      }}
      onClick={onClick}
    >
      <CardContent>
        {/* Top Section */}
        <Box display="flex" alignItems="center" gap={1} mb={1}>
          <Box
            sx={{
              backgroundColor: "#0a0a56",
              borderRadius: 2,
              p: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
            }}
          >
            {icon}
          </Box>
          <Typography variant="subtitle2" color="textSecondary">
            {title}
          </Typography>
        </Box>

        {/* Value */}
        <Typography sx={{ fontSize: "1rem" }} fontWeight="bold" gutterBottom>
          {value}
        </Typography>

        {/* Percentage */}
        <Box display="flex" alignItems="center" gap={0.5}>
          <Box
            display="flex"
            alignItems="center"
            px={1}
            py={0.5}
            borderRadius={2}
            sx={{
              backgroundColor: isPositive
                ? "rgba(0, 200, 83, 0.1)"
                : "rgba(255, 82, 82, 0.1)",
              color: isPositive ? "green" : "red",
              fontSize: "0.75rem",
              fontWeight: 500,
            }}
          >
            <ArrowUpwardIcon
              sx={{
                fontSize: "0.75rem",
                transform: isPositive ? "rotate(0deg)" : "rotate(180deg)",
              }}
            />
            {percentage}%
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatsCard;
